
import {createStore, applyMiddleware, combineReducers} from 'redux';
import * as ReactRedux from 'react-redux';
import thunk from 'redux-thunk';

var logger;
if (process.env.NODE_ENV === 'development') {
	logger = require('redux-logger');
}

class Actions {

	constructor(initialState, runsOnServer = false) {

		initialState._tmp = {};
		this.reducer = this.reducer.bind(this);
		this.reducers = {};
		this.runsOnServer = runsOnServer;

		if (logger === undefined || runsOnServer) {
			this.store = createStore(this.reducer, initialState, applyMiddleware(thunk));
		} else {
			this.store = createStore(this.reducer, initialState, applyMiddleware(thunk, logger.default));
		}
	}

	action(type, parameters = {}) {
		return {
			type: type,
			...parameters
		};
	}

	dispatch(action) {
		if (this.runsOnServer && action.type != "SET_INITIAL_STATE" && action.type != "ADD_INITIAL_STATE") {
			return;
		}
		return this.store.dispatch(action);
	}

	getState() {
		return this.store.getState();
	}

	reducer(state, action) {

		if (action.type == "SET_INITIAL_STATE") {
			state = this.reducers[action.reducerName].initialState(state);
		}

		if (action.type == "ADD_INITIAL_STATE") {
			if (action.stateScope == "") {
				for (let i in action.initialState) {
					state = dot.set(state, i, action.initialState[i]);
				}
			} else {
				state = dot.set(state, action.stateScope, dot.get(action.initialState, action.stateScope));
			}
		}

		for (let applicationName in this.reducers) {
			state = this.reducers[applicationName].reducer(state, action);
		}

		return state;
	}

	addReducer(name, reducer) {
		this.reducers[name] = reducer;

		if (this.reducers[name].initialState !== undefined) {
			this.dispatch(this.action('SET_INITIAL_STATE', {reducerName: name}));
		}
	}

	defaultState(state, path, defaultValues) {
		if (dot.get(state, path)) return state;
		return dot.set(state, path, defaultValues);
	}

	addInitialState(stateScope, initialState) {
		this.dispatch(this.action('ADD_INITIAL_STATE', {stateScope: stateScope, initialState: initialState}));
	}

}

module.exports = Actions



// WEBPACK FOOTER //
// ./jsx/Actions.js